import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function DashboardWidgetCard({ icon: Icon, iconClass, title, footerLabel, footerTo, testId, children }) {
  const navigate = useNavigate();
  return (
    <div className="bg-white/[0.03] border border-white/5 rounded-2xl p-4 flex flex-col" data-testid={testId}>
      <div className="flex items-center gap-2 mb-3">
        <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${iconClass}`}><Icon className="w-4 h-4" /></div>
        <span className="text-sm font-semibold text-white">{title}</span>
      </div>
      <div className="space-y-2.5 flex-1">{children}</div>
      {footerTo && (
        <button onClick={() => navigate(footerTo)} data-testid={`${testId}-footer-link`} className="text-xs text-cyan-400 hover:text-cyan-300 mt-3 flex items-center gap-1 self-start">
          {footerLabel} <ArrowUpRight className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}

export function EmptyWidgetState({ text }) {
  return <p className="text-xs text-slate-500 text-center py-4">{text}</p>;
}
